var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPudoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    d: "m11.9285 3.2425-1.5-2.5A.5.5 0 0 0 10 .5H2a.5.5 0 0 0-.4285.2425l-1.5 2.5A.5.5 0 0 0 0 3.5c-.002 1.102.8895 1.9972 1.9915 2h.004a1.987 1.987 0 0 0 1.337-.5125c.757.6842 1.909.6842 2.666 0 .7574.6857 1.9111.6857 2.6685 0A1.996 1.996 0 0 0 12 3.5a.5.5 0 0 0-.0715-.2575M10.008 6.5a3.005 3.005 0 0 1-1.3395-.314l-.0075.0035a2.974 2.974 0 0 1-2.282.155 3.05 3.05 0 0 1-.38-.157l-.0055.0025a2.97 2.97 0 0 1-2.2815.1545 3.05 3.05 0 0 1-.3795-.157 2.995 2.995 0 0 1-1.337.3125A3.1 3.1 0 0 1 1.5 6.455V11.5a.5.5 0 0 0 .5.5h3V9h2v3h3a.5.5 0 0 0 .5-.5V6.453a3 3 0 0 1-.492.047"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPudoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pudo-icon.43be229cd87cb5a9468c5407bb6496b4.svg";